import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Button, TextField, Typography } from "@mui/material";

import Select from "react-select";
import useCompanies from "../../queries/gift/companies";
import parseRequirements from "../../utils/parseRequirements";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useCreateGift from "../../mutation/gift/createGift";
import useCreateAudit from "../../mutation/audit/createAudit";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  description: yup.string().required("Description is required"),
  code: yup.string().required("Gift Code is required"),
  company: yup.number().required("Company is required"),
});

const NewGift = (props) => {
  const history = useHistory();

  const [auditResponse, setAuditData] = useCreateAudit();

  const [companyOptions, setCompanyOptions] = useState([]);
  const [companyResponse, reset] = useCompanies();

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  useEffect(() => {
    if (companyResponse.data) {
      setCompanyOptions(parseRequirements(companyResponse.data));
    }
  }, [companyResponse]);

  const goBack = () => {
    window.location.href = "/dashboard/gifts";
  };

  const onSubmit = (values) => {
    values.counter = 0;
    Swal.fire({
      title: "Create Updates",
      html: `<h4>Please provide a description before submitting your changes</h4>
      <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: values,
          type: "gift",
          action: "create",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAuditData(result.value);
      }
    });
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Gift creation Audit Created",
        });
        history.push("/dashboard/gifts");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          Swal.fire({
            icon: "error",
            title: "Error",
            text: message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const companyChange = (value) => {
    if (value != null) {
      setValue("company", value.value);
    }
  };

  const renderContent = () => {
    return (
      <FormPageShell>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormPageCard>
            <FormPageHeader
              title="New Gift"
              onBack={goBack}
              subtitle="Please fill in the required fields."
            />
            <TextField
              name="name"
              margin="normal"
              fullWidth
              label="Name*"
              variant="outlined"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={auditResponse.loading}
            />
            <TextField
              name="description"
              margin="normal"
              fullWidth
              label="Description*"
              variant="outlined"
              inputRef={register}
              error={errors.description != null}
              helperText={
                errors.description != null
                  ? errors.description.message
                  : null
              }
              disabled={auditResponse.loading}
            />
            <TextField
              name="code"
              margin="normal"
              fullWidth
              label="Gift Code*"
              variant="outlined"
              inputRef={register}
              error={errors.code != null}
              helperText={errors.code != null ? errors.code.message : null}
              disabled={auditResponse.loading}
            />
            <Typography sx={{ fontSize: 16, fontWeight: "bold", mt: 1 }}>
              Company (from RMS Cloud)
            </Typography>
            {companyOptions.length > 0 && (
              <div>
                <Controller
                  name="company"
                  control={control}
                  render={({ ...props }) => {
                    return (
                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: errors.company
                              ? "red"
                              : provided.borderColor,
                          }),
                        }}
                        options={companyOptions}
                        onChange={companyChange}
                        disabled={auditResponse.loading}
                      />
                    );
                  }}
                />
                {errors.company && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mx: 1.75, mt: 0.375, display: "block" }}
                  >
                    {errors.company.message}
                  </Typography>
                )}
              </div>
            )}
          </FormPageCard>
          <FormPageCard sx={{ mt: 2 }}>
            <FormActions>
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="primary"
                disabled={auditResponse.loading}
              >
                Submit
              </Button>
            </FormActions>
          </FormPageCard>
        </form>
      </FormPageShell>
    );
  };

  return renderContent();
};

export default NewGift;
